import "./index.scss";
const ModalCancelOrder = ({
  cancelAction,
  orderToCancel,
  closeModalCancel,
}) => {
  const confirmCancel = () => {
    cancelAction();
    closeModalCancel();
  };
  const cancelCancelOrder = () => {
    closeModalCancel();
  };

  return (
    <div className="modal-cancel-container">
      <div className="modal-cancel-header">
        <i
          className="bx bx-x"
          style={{ fontSize: 32 }}
          onClick={() => closeModalCancel()}
        ></i>
      </div>
      <div className="modal-cancel-body">
        Êtes-vous sûr de vouloir annuler l'ordre ?
      </div>
      <div className="modal-cancel-footer">
        <button
          className="btn-modal-cancel-cancel"
          onClick={() => cancelCancelOrder()}
        >
          Annuler
        </button>
        <button
          className="btn-modal-cancel-confirm"
          onClick={() => confirmCancel()}
        >
          Confirmer
        </button>
      </div>
    </div>
  );
};
export default ModalCancelOrder;
